export const USER_ACCOUNT_SET_USER_ACCOUNTS = "user-account/set-user-accounts";
export const USER_ACCOUNT_SET_SELECTED_USER_ACCOUNT = "user-account/set-selected-user-account";
export const USER_ACCOUNT_COPY_USER_ACCOUNTS = "user-account/copy-user-accounts";
